module.exports = __webpack_public_path__ + "static/media/vi.3efbe9d7.svg";